import { PrismicError } from "../PrismicError.js";
const findRef = (refs, predicate) => {
  const ref = refs.find((ref2) => predicate(ref2));
  if (!ref) {
    throw new PrismicError("Ref could not be found.", void 0, void 0);
  }
  return ref;
};
export {
  findRef
};
//# sourceMappingURL=findRef.js.map
